import { observable } from 'mobx';

import { SerializedData, Store } from 'bernie-core';
import { BrandPolicies } from 'types/information/brand-policies/brand-policies';

export class PoliciesStore extends Store {
  @observable public brandPolicies?: BrandPolicies;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}
